import type { RouteObject } from "react-router"

export const nodesRoutes: RouteObject[] = [
  {
    path: "nodes",
    lazy: () => import("./nodes-page").then((m) => ({ Component: m.NodesPage })),
  },
]
